<template>
  <div class="empty">
    <img class="empty_img" src="../../assets/empty.png" />
    <div class="desc">{{ title }}</div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      // default: '鼠标拖拽也可以上传文件哦~',
      default: '空空如也~',
    },
  },
};
</script>

<style lang="scss" scoped>
.empty {
  text-align: center;
  width: 100%;
  color: $grey2;
  font-size: 19px;
  font-weight: 500;
  line-height: 22px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  .empty_img {
    user-select: none;
    -webkit-user-drag: none;
    margin-bottom: 12px;
    width: 120px;
  }
}
</style>
